import cx from 'classnames';
import { createPropInlineStyle } from '../../utils';
import styles from './index.module.css';

/**
 * @typedef {"full" | "auto" | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | String} height
 *
 * @param height {height}
 * @returns - [className, style]
 *
 * @example
 * const [heightClassName, heightStyle] = getHeight('full');
 */
const getHeight = height => {
  const spaces = ['full', 'auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const heightClassName = cx({
    [styles.hFull]: height === 'full',
    [styles.hAuto]: height === 'auto',
    [styles.h0]: height === 0,
    [styles.h1]: height === 1,
    [styles.h2]: height === 2,
    [styles.h3]: height === 3,
    [styles.h4]: height === 4,
    [styles.h5]: height === 5,
    [styles.h6]: height === 6,
    [styles.h7]: height === 7,
    [styles.h8]: height === 8,
    [styles.h9]: height === 9,
    [styles.h10]: height === 10,
    [styles.h11]: height === 11
  });
  const heightStyle = createPropInlineStyle(height, spaces);

  /**
   * We return an array and not an object, for renaming reasons.
   */
  return [heightClassName, heightStyle];
};

/**
 * @typedef {"full" | "auto" | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | String} maxHeight
 *
 * @param maxHeight {maxHeight}
 * @returns - [className, style]
 *
 * @example
 * const [maxHeightClassName, maxHeightStyle] = getMaxHeight('full');
 */
export const getMaxHeight = maxHeight => {
  const spaces = ['full', 'auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const maxHeightClassName = cx({
    [styles.mhFull]: maxHeight === 'full',
    [styles.mhAuto]: maxHeight === 'auto',
    [styles.mh0]: maxHeight === 0,
    [styles.mh1]: maxHeight === 1,
    [styles.mh2]: maxHeight === 2,
    [styles.mh3]: maxHeight === 3,
    [styles.mh4]: maxHeight === 4,
    [styles.mh5]: maxHeight === 5,
    [styles.mh6]: maxHeight === 6,
    [styles.mh7]: maxHeight === 7,
    [styles.mh8]: maxHeight === 8,
    [styles.mh9]: maxHeight === 9,
    [styles.mh10]: maxHeight === 10,
    [styles.mh11]: maxHeight === 11
  });
  const maxHeightStyle = createPropInlineStyle(maxHeight, spaces);

  /**
   * We return an array and not an object, for renaming reasons.
   */
  return [maxHeightClassName, maxHeightStyle];
};
export default getHeight;